import React from "react";
import { useMeet } from "util/useMeet";
import { getAllAttemptsForMeet } from "util/meetHelper";
import filter from "lodash/filter";
import sortBy from "lodash/sortBy";
import { parseISO } from "date-fns";
import Select from "components/select/Select";

const ActivityLog = () => {
  const meet = useMeet();
  const [platformId, setPlaformId] = React.useState("ALL");

  const activityLog = React.useMemo(() => {
    const attempts = getAllAttemptsForMeet(meet);

    const activities = [];

    for (const attempt of Object.values(attempts)) {
      const lifter = attempt.lifterId
        ? meet.lifters[attempt.lifterId]
        : undefined;

      const platform = lifter?.platformId
        ? meet.platforms[lifter?.platformId]
        : undefined;
      const attemptChanges = filter(
        attempt.changes,
        (c) => c.attribute === "result",
      );

      const sortedAttemptChanges = sortBy(attemptChanges, "timeStamp");
      for (const change of sortedAttemptChanges) {
        const timeStamp = parseISO(change.timeStamp);
        const formattedDate = timeStamp.toLocaleDateString();
        const formattedTime = timeStamp.toLocaleTimeString();

        const result = change.value
          ? `marked ${change.value}`
          : "result cleared";

        if (platformId === "ALL" || platformId === platform?._id) {
          activities.push({
            timeStamp,
            formattedString: `${formattedDate} ${formattedTime} ${lifter?.name} ${attempt.liftName} ${attempt.attemptNumber} ${result} on platform ${platform?.name ?? ""}`,
          });
        }
      }
    }

    const sortedActivities = sortBy(activities, "timeStamp");

    return sortedActivities;
  }, [meet, platformId]);

  const platformOptions = React.useMemo(() => {
    const platforms = Object.values(meet.platforms).map((platform) => {
      return { label: `Platform ${platform.name ?? ""}`, value: platform._id };
    });
    return [{ label: "ALL PLATFORMS", value: "ALL" }].concat(
      sortBy(platforms, "label"),
    );
  }, [meet.platforms]);

  return (
    <div className="activity-log">
      <h2>Activity Log</h2>
      <div>
        <Select
          className="platform-select"
          name="dateFormat"
          value={platformId}
          options={platformOptions}
          onChange={(value) => setPlaformId(String(value ?? "ALL"))}
          clearable={false}
          ariaLabel="Select Platform"
        />
      </div>

      {activityLog.map((activity) => {
        return (
          <div key={activity.formattedString}>{activity.formattedString}</div>
        );
      })}
    </div>
  );
};

export default ActivityLog;
